<div class="flex flex-col w-full h-full">
    <!-- Header -->
<!--    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">-->
<!--        <div class="text-lg font-medium">-->
<!--            {{ step.title}}-->
<!--        </div>-->
<!--    </div>-->

<!--    order?: number;-->
<!--    title?: string;-->
<!--    subtitle?: string;-->
<!--    content?: string;-->
<!--    videoId?: string;-->
<!--    length?: number;    -->

    <!-- Content -->
    <mat-dialog-content class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <div *ngIf="step?.content && !step.videoId" [innerHTML]="step.content" class="prose prose-sm max-w-max mx-auto sm:my-2 lg:mt-4 p-6 sm:p-10 sm:py-12"></div>
        <div *ngIf="step.videoId" class="text-sm text-hint -mt-6 -mb-8 min-w-64 sm:min-w-128 md:min-w-256 justify-center max-w-max mx-auto">Video-ul se va incarca in curand...</div>
        <youtube-video *ngIf="step.videoId" [video_id]="step.videoId"></youtube-video>
    </mat-dialog-content>

    <!-- Actions -->
    <div class="flex flex-0 items-center justify-end h-16 px-4 ">
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>{{ 'Close' | transloco }}</button>
        </mat-dialog-actions>
    </div>
</div>
